import { Grid } from "@mui/material"
import MDBox from "components/MDBox"
import DashboardLayout from "examples/LayoutContainers/DashboardLayout"
import Header from "examples/Header"
import WeeklyCalendar from "./components/WeeklCalendar"
import MonthCalendar from "./components/MonthCalendar"
import calendarStyles from "./style"
import { useCallback, useState } from "react"
import moment from "moment"
import { useMyDevelopmentAPIs } from "shared/redux/endpoints/endPointMyDevelopment"
import { useDispatch, useSelector } from "react-redux"
import { selectAuth } from "shared/redux/slices/authSlice"
// import type { Error400 } from "utilities/toastUtil";
import { ToastUtil } from "utilities/toastUtil"
import { resetCallGetCalendarWorkshop } from "shared/redux/slices/sliceMyCalendar"
import WeeklyCalendarLXO from "components/WeeklyCalendarLXO/WeeklyCalendarLXO"
import { RoleLabel } from "constant/Role"
import { Role } from "constant/Role"
import TeacherManagementCalendarSection from "components/TeacherManagementCalendarSection/TeacherManagementCalendarSection"
import ModalWorkShop from "components/ModalWorkShop/ModalWorkShop"
import ModalLeaveApplication from "components/ModalLeaveApplication/ModalLeaveApplication"
import ModalLeaveRelatedInfomation from "components/ModalLeaveRelatedInfomation/ModalLeaveRelatedInfomation"
import ModalMyCalendarStudentAtRisk from "components/ModalMyCalendarStudentAtRisk/ModalMyCalendarStudentAtRisk"
// import type { IWeeklyCalendarProps } from "./components/WeeklCalendar";
import { useCreateLeaveRequestMutation } from "shared/redux/endpoints/leaveRequest"
import { useUploadFileMutation } from "shared/redux/endpoints/employee"
import {
  pickUploadFiles,
  mapUploadedToDtoAttachments,
  mapExistingUrlToDtoAttachments,
} from "shared/utils/common"

const tabs = [
  { label: "All", value: "all" },
  {
    label: "Lesson",
    value: "session",
  },
  {
    label: "Demo/PT",
    value: "pt",
  },
  {
    label: "Tasks",
    value: "task",
  },
  {
    label: "EOCC & Test",
    value: "test",
  },
  {
    label: "Training/Workshop",
    value: "training",
  },
  { label: "Events", value: "events" },
]

function MyCalendar() {
  const dispatch = useDispatch()
  const auth = useSelector(selectAuth)
  const role = auth.role
  const { user } = auth
  const [start, setStart] = useState(
    moment().startOf("isoWeek").weekday(1).format("YYYY-MM-DD")
  )
  const [dataRelatedInformation, setDataRelatedInformation] = useState([])
  const [tab, setTab] = useState(tabs[0])
  const [createLeaveRequest] = useCreateLeaveRequestMutation()
  const [uploadFile] = useUploadFileMutation()

  const [end, setEnd] = useState(
    moment().startOf("isoWeek").weekday(7).format("YYYY-MM-DD")
  )
  const [payloadSubmit, setPayloadSubmit] = useState({})
  const [isOpenModalLeave, setIsOpenModalLeave] = useState(false)
  const [
    isOpenModalLeaveRelatedInformation,
    setIsOpenModalLeaveRelatedInformation,
  ] = useState(false)

  // get instance call API
  const getDataPageOfWorkshopTab =
    useMyDevelopmentAPIs.useGetDataPageOfWorkshopTab()

  // func call API
  const callGetDataPageOfWorkshopTab = useCallback(async () => {
    let email = user.email
    await getDataPageOfWorkshopTab({ email }, undefined, undefined, (error) => {
      ToastUtil.showToastError400(error)
    })
  }, [getDataPageOfWorkshopTab])

  // result API
  const { dataWorkShop } = useSelector(
    (state) => state.myCalendar.callGetCalendarWorkshop
  )

  const propertiesWeeklyCalendar = {
    outerDate: start,
    dataWorkShop: dataWorkShop,
    onChangeTab: async (tab) => {
      if (tab.value === "all" || tab.value === "training") {
        await callGetDataPageOfWorkshopTab()
      } else {
        dispatch(resetCallGetCalendarWorkshop())
      }
    },
  }

  const propertiesMonthCalendar = {
    start,
    setStart,
    end,
    setEnd,
    dataWorkShop,
  }

  async function submitLeave(form) {
    const selectedFiles = Array.isArray(form?.attachments)
      ? form.attachments
      : []

    // 1) Upload nếu có File mới
    const filesToUpload = pickUploadFiles(selectedFiles)

    let uploaded = []
    if (filesToUpload.length > 0) {
      const formData = new FormData()
      filesToUpload.forEach((file) => {
        formData.append("attachments", file)
      })

      uploaded = await uploadFile(formData)

      // uploaded items đúng format backend bạn đưa
    }

    // 2) Map attachments vào dto
    const attachments = [
      ...mapExistingUrlToDtoAttachments(selectedFiles),
      ...mapUploadedToDtoAttachments(uploaded),
    ]

    // 3) Dedup theo url (tránh trùng nếu UI lỡ giữ cả url + File)
    const seen = new Set()
    const dedupedAttachments = attachments.filter((a) => {
      const key = a.url
      if (!key) return false
      if (seen.has(key)) return false
      seen.add(key)
      return true
    })

    // 4) Build dto submit
    const dto = {
      // ...form,
      leaveType: form?.leaveType?.value,
      startDate: moment(form.fromDate).format("YYYY-MM-DD"),
      endDate: moment(form.toDate).format("YYYY-MM-DD"),
      dayType: form.isHalfDay ? "HALF_DAY" : "FULL_DAY",
      reason: form.reason ?? "Medical leave",
      approverId: form.approver?.userId || form?.approver?.id,
      notificationRecipientIds: form.notifyTo?.map((u) => u.id),
      uploadedAttachments: dedupedAttachments,
    }

    return createLeaveRequest(dto).then((result) => {
      console.log(result, "MyCalendar ~ submitLeave ~ result")
    })
  }

  const propsModalLeaveRelatedInformation = {
    isOpen: isOpenModalLeaveRelatedInformation,
    onClose: () => setIsOpenModalLeaveRelatedInformation(false),
    onSubmit: async () => {
      try {
        submitLeave(payloadSubmit)

        setIsSubmitSuccess(true)
      } catch (e) {
        setIsSubmitSuccess(false)
      }
      setIsOpenModalLeaveRelatedInformation(false)
      setIsOpenModalLeaveSubmitStatus(true)
    },
    dataRelatedInformation: dataRelatedInformation,
  }

  const propsModalLeaveApplication = {
    isOpen: isOpenModalLeave,
    onClose: () => setIsOpenModalLeave(false),
    onSubmit: (data) => {
      setPayloadSubmit(data)
      setIsOpenModalLeave(false)
      setIsOpenModalLeaveRelatedInformation(true)
    },
  }

  const propsTeacherManagementCalendarSection = {
    tab,
    setTab,
  }

  return (
    <DashboardLayout>
      <Header />
      <MDBox sx={calendarStyles} className="calendar-my-calendar">
        <MDBox
          sx={() => ({
            width: "100%",
          })}
        >
          <Grid container columnSpacing={2} rowGap={2}>
            <Grid item xs={12} xl>
              <TeacherManagementCalendarSection
                {...propsTeacherManagementCalendarSection}
              />
            </Grid>
          </Grid>
        </MDBox>
      </MDBox>

      {isOpenModalLeave && (
        <ModalLeaveApplication {...propsModalLeaveApplication} />
      )}
      {isOpenModalLeaveRelatedInformation && (
        <ModalLeaveRelatedInfomation {...propsModalLeaveRelatedInformation} />
      )}
    </DashboardLayout>
  )
}

export default MyCalendar
